var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "none"
    },
    height: 28,
    width: 28,
    id: "svg14",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs18"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    className: "cls-13",
    d: "m 23.4654,8.4630146 -7.135009,5.4572394 a 3.6769363,3.4992994 0 0 1 -4.59617,0 L 4.5335526,8.4630146",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.5,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    className: "cls-13",
    d: "M 8.3994418,3.8254174 H 19.60768 a 5.9072543,5.9072543 0 0 1 4.259441,1.8809943 6.0316176,6.0316176 0 0 1 1.554541,4.3993493 v 7.772703 a 6.0160722,6.0160722 0 0 1 -1.554541,4.39935 5.8606181,5.8606181 0 0 1 -4.259441,1.89654 H 8.3994418 a 5.9072543,5.9072543 0 0 1 -5.813982,-6.218162 v -7.772703 a 5.9072543,5.9072543 0 0 1 5.813982,-6.3580716 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a63fbe67430897e3a74062be56dcdd99.svg";
export { ForwardRef as ReactComponent };